var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { throttle } from '@feb-team/data-logic';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import qs from './qs';
import { DefaultIcon } from '@feb-team/legao-icons-react';
import { addEventListenerWrap } from '../../Utils/react';
import { scrollTo } from '../../Utils/browser';
var TopSvg = function () { return (React.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 1075 1024" },
    React.createElement("path", { fill: "currentColor", d: "M551.915 186.513l1.31 1.31 420.838 459.096c7.961 8.685 7.375 22.18-1.31 30.141-3.934 3.607-9.078 5.607-14.415 5.607l-250.196-0.002 0.025 320.002c0 11.782-9.551 21.333-21.333 21.333h-298.667c-11.782 0-21.333-9.551-21.333-21.333l-0.042-320.002-250.129 0.002c-11.782 0-21.333-9.551-21.333-21.333 0-5.337 2.001-10.481 5.607-14.415l420.838-459.096c7.961-8.685 21.456-9.272 30.141-1.31zM1017.5 0.001c17.673 0 32 14.327 32 32v3.654c0 17.673-14.327 32-32 32h-960c-17.673 0-32-14.327-32-32v-3.654c0-17.673 14.327-32 32-32h960z" }))); };
var TopIcon = function (props) { return React.createElement(DefaultIcon, __assign({ component: TopSvg }, props)); };
var BackTop = /** @class */ (function (_super) {
    __extends(BackTop, _super);
    function BackTop(props) {
        var _this = _super.call(this, props) || this;
        _this.handleScroll = function () {
            var _a = _this.props, onToggle = _a.onToggle, visibilityHeight = _a.visibilityHeight;
            var top = 0;
            if (_this.scrollContainer === window) {
                top = window.pageYOffset;
            }
            else if (_this.scrollContainer) {
                var scrollContainer = _this.scrollContainer;
                top = scrollContainer.scrollTop;
            }
            var isShow = !!(visibilityHeight && top > visibilityHeight);
            _this.setState({
                show: isShow,
            });
            onToggle(isShow);
        };
        _this.handleClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, duration = _a.duration;
            if (_this.scrollContainer) {
                onClick();
                scrollTo(0, 0, { duration: duration }, function () { }, _this.scrollContainer);
            }
        };
        _this.state = {
            show: false,
        };
        _this.scrollEvent = null;
        _this.scrollContainer = window;
        _this.handleScroll = throttle(_this.handleScroll, 100);
        return _this;
    }
    BackTop.prototype.componentDidMount = function () {
        var scrollContainer = this.props.scrollContainer;
        if (scrollContainer === window) {
            this.scrollContainer = scrollContainer;
        }
        else {
            var ele = qs(scrollContainer);
            this.scrollContainer = ele ? ele : window;
        }
        this.scrollEvent = addEventListenerWrap(this.scrollContainer, 'scroll', this.handleScroll);
    };
    BackTop.prototype.componentWillUnmount = function () {
        if (this.scrollEvent) {
            this.scrollEvent.remove();
        }
    };
    BackTop.prototype.render = function () {
        var _a = this.props, visibilityHeight = _a.visibilityHeight, right = _a.right, bottom = _a.bottom, zIndex = _a.zIndex, onClick = _a.onClick, duration = _a.duration, onToggle = _a.onToggle, children = _a.children, scrollContainer = _a.scrollContainer, style = _a.style, rest = __rest(_a, ["visibilityHeight", "right", "bottom", "zIndex", "onClick", "duration", "onToggle", "children", "scrollContainer", "style"]);
        var show = this.state.show;
        if (!show) {
            return null;
        }
        var boxCls = [
            'fixed',
            'z-50',
            'flex',
            'justify-center',
            'items-center',
            'w-12',
            'h-12',
            'p-px-10',
            'rounded',
            'box-border',
            'cursor-pointer',
            'bg-black',
            'opacity-40',
            'text-2xl',
        ];
        var setStyle = __assign({ right: right,
            zIndex: zIndex,
            bottom: bottom }, style);
        return (React.createElement(React.Fragment, null,
            React.createElement(DivTag, __assign({ name: BackTop.NAME, atomics: boxCls, onClick: this.handleClick, style: setStyle }, rest), children ? (children) : (React.createElement(React.Fragment, null,
                React.createElement(SpanTag, { atomics: [
                        'absolute',
                        'flex',
                        'items-center',
                        'justify-center',
                        'cursor-pointer',
                        'text-white',
                        'w-full',
                        'h-full',
                    ], className: "top-icon" },
                    React.createElement(TopIcon, null)))))));
    };
    BackTop.defaultProps = defaultProps;
    BackTop.NAME = 'back-top';
    BackTop.displayName = 'BackTop';
    return BackTop;
}(PureComponent));
export { BackTop };
